import { render, staticRenderFns } from "./vehicleRetrun.vue?vue&type=template&id=38ffcad8&"
import script from "./vehicleRetrun.vue?vue&type=script&lang=js&"
export * from "./vehicleRetrun.vue?vue&type=script&lang=js&"
import style0 from "./vehicleRetrun.vue?vue&type=style&index=0&id=38ffcad8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports